import { useCallback, useRef } from 'react'
import { apiClient } from '@/api/client'

const SESSION_KEY = 'enterprise_session_id'

function generateId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID()
  }
  // Fallback para contextos no seguros (HTTP)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
}

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY)
    if (!id) {
      id = generateId()
      sessionStorage.setItem(SESSION_KEY, id)
    }
    return id
  } catch {
    return generateId()
  }
}

export function useEnterpriseTracking() {
  const sessionId = useRef(getSessionId())

  const trackVisita = useCallback((newsletter = '') => {
    apiClient
      .post('/enterprise-stats/track/visita/', {
        session_id: sessionId.current,
        newsletter,
      })
      .catch(() => {})
  }, [])

  const trackScroll = useCallback((newsletter: string, scrollDepth: number) => {
    apiClient
      .post('/enterprise-stats/track/scroll/', {
        session_id: sessionId.current,
        newsletter,
        scroll_depth: scrollDepth,
      })
      .catch(() => {})
  }, [])

  const trackClic = useCallback((newsletter: string, url: string, texto: string) => {
    apiClient
      .post('/enterprise-stats/track/clic/', {
        session_id: sessionId.current,
        newsletter,
        url_destino: url,
        url_texto: texto,
      })
      .catch(() => {})
  }, [])

  return { trackVisita, trackScroll, trackClic }
}
